import { Link } from "react-router";
import { PageTitle } from "../components/Heading";

export default function NotFound() {
  return (
    <section className="space-y-4">
      <PageTitle>Not found</PageTitle>
      <p className="text-sm text-neutral-400">
        No route matches this URL. Firebase Hosting serves index.html for any path it does not
        recognise, so a deep link to a deleted page lands here rather than on a 404 from the CDN.
      </p>
      <Link to="/" className="btn btn-ghost btn-sm">
        Home
      </Link>
    </section>
  );
}
